const getDateRange = require("../components/dumb/IntervalFilterCustom/utils/getDateRange");
const param = require("mn-utils/param");
const formatTime = require("mn-utils/formatTime");
const {API_URL_HTTP} = require("../config/api");

module.exports = (filter, sort, report) => {
  const dateMask = '{yyyy}-{mm}-{dd}';
  const key = 'csv';

  const {
    from,
    to,
    interval,
    search,
    ...rest
  } = filter;

  let dateFrom, dateTo;

  if (interval) {
    const dates = getDateRange(filter);

    dateFrom = dates.from;
    dateTo = dates.to;
  } else {
    dateFrom = from;
    dateTo = to;
  }

  const params = {
    search: search || null,
    from: dateFrom && formatTime(dateFrom, dateMask),
    to: dateTo && formatTime(dateTo, dateMask),
    ...rest
  };

  if (sort['name']) {
    params['order_by'] = sort['name'];
    params['order_kind'] = sort['type'];
  }

  const queryString = param(params);

  const url = report.url + key + (queryString ? ('?' + queryString) : '');
  const name = report.prefix
    + (dateFrom ? '_' + formatTime(dateFrom, '{yyyy}-{mm}-{dd}') : '')
    + (dateTo ? '_' + formatTime(dateTo, '{yyyy}-{mm}-{dd}') : '')
    + '.' + key;

  const link = document.createElement('a');
  link.download = name;
  link.href = API_URL_HTTP + url;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
